import React from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { IconButton, TableRow as MuiTableRow, styled, TableCell, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { ClientDealTableRow, DealTableColumn } from "store/types";

interface Props {
  row: ClientDealTableRow;
  rowKey: string;
  level: number;
  expandedRows: string[];
  handleExpandRow: (rowKey: string) => void;
  columns: DealTableColumn[];
  groupByCounter: number;
}

const StyledTableRowCell = styled(TableCell)({
  fontSize: "14px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  borderBottom: "1px solid #E5E9EB"
});

const StyledText = styled(Typography)({
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  textAlign: "center",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 400
});

export const TableRow: React.FC<Props> = ({
  row,
  rowKey,
  level,
  expandedRows,
  handleExpandRow,
  columns,
  groupByCounter
}) => {
  // const showChildren = level + 1 < groupByCounter;

  return (
    <React.Fragment key={rowKey}>
      <MuiTableRow sx={{ height: "48px" }}>
        <StyledTableRowCell>
          {/* {showChildren && row.children && row.children.length > 0 && ( */}
          {row.children && row.children.length > 0 && (
            <IconButton
              onClick={() => handleExpandRow(rowKey)}
              sx={{
                mr: 1,
                p: 0,
                color: "#071F35",
                transform: expandedRows.includes(rowKey) ? "rotate(180deg)" : "none",
                transition: "transform 0.2s"
              }}
            >
              <KeyboardArrowDownIcon />
            </IconButton>
          )}
        </StyledTableRowCell>
        <StyledTableRowCell sx={{ maxWidth: 120 }}>
          <MaterialTooltip title={row.title} isShow>
            <StyledText sx={{ fontWeight: 500 }}>{row.title}</StyledText>
          </MaterialTooltip>
        </StyledTableRowCell>
        {columns.map(({ key, postfix }) => {
          const value = row.valueData[key];

          const cellPostfix = row.postfixes?.[key] || postfix || row.postfix;

          const isNegative = value && value < 0;

          const prefix = value && cellPostfix && cellPostfix !== "%" ? cellPostfix : "";
          const suffix = value && cellPostfix === "%" ? cellPostfix : "";

          return (
            <StyledTableRowCell sx={{ maxWidth: 120 }} key={key}>
              <MaterialTooltip title={value} isShow>
                <StyledText sx={{ textAlign: "left" }}>
                  {isNegative ? "-" : ""}
                  {prefix}
                  {isNegative ? value * -1 : value}
                  {suffix}
                </StyledText>
              </MaterialTooltip>
            </StyledTableRowCell>
          );
        })}
      </MuiTableRow>
      {
        // showChildren &&
        expandedRows.includes(rowKey) &&
          row.children?.map((child, index) => (
            <TableRow
              key={`${rowKey}-${index}`}
              row={child}
              rowKey={`${rowKey}-${index}`}
              level={level + 1}
              expandedRows={expandedRows}
              handleExpandRow={handleExpandRow}
              columns={columns}
              groupByCounter={groupByCounter}
            />
          ))
      }
    </React.Fragment>
  );
};
